import { render } from "./Test6.vue?vue&type=template&id=63302b2f&ts=true"
import script from "./Test6.vue?vue&type=script&lang=ts"
export * from "./Test6.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__